import React, { useEffect, useState, useRef } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { CModal } from '@coreui/react';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';
import { generateAxiosInstanceSection } from '../hooks/useAuthorizedRequestForSection';
import ReactPlayer from 'react-player';

const DashboardCompetitiveExam = () => {
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection();

    // const [isActive, setIsactive] = useState(false);
    const [activeTab, setActiveTab] = useState("name");
    const [visible, setVisible] = useState(false);
    const [modalData, setModalData] = useState("");


    const [examNameList, setExamNameList] = useState([]);
    const [examLessonList, setExamLessonList] = useState([]);
    const [examTopicList, setExamTopicList] = useState([]);
    const [examSubTopicList, setExamSubTopicList] = useState([]);

    const [startIndexExamNameList, setStartIndexExamNameList] = useState(null);
    const [startIndexExamLessonList, setStartIndexExamLessonList] = useState(null);
    const [startIndexExamTopicList, setStartIndexExamTopicList] = useState(null);
    const [startIndexExamSubTopicList, setStartIndexExamSubTopicList] = useState(null);

    const [currPageExamNameList, setCurrPageExamNameList] = useState(1);
    const [currPageExamLessonList, setCurrPageExamLessonList] = useState(1);
    const [currPageExamTopicList, setCurrPageExamTopicList] = useState(1);
    const [currPageExamSubTopicList, setCurrPageExamSubTopicList] = useState(1);

    const [itemsPerPageExamNameList, setItemsPerPageExamNameList] = useState(10);
    const [itemsPerPageExamLessonList, setItemsPerPageExamLessonList] = useState(10);
    const [itemsPerPageExamTopicList, setItemsPerPageExamTopicList] = useState(10);
    const [itemsPerPageExamSubTopicList, setItemsPerPageExamSubTopicList] = useState(10);

    const [displayedDataExamNameList, setDisplayedDataExamNameList] = useState([]);
    const [displayedDataExamLessonList, setDisplayedDataExamLessonList] = useState([]);
    const [displayedDataExamTopicList, setDisplayedDataExamTopicList] = useState([]);
    const [displayedDataExamSubTopicList, setDisplayedDataExamSubTopicList] = useState([]);

    const [totalPagesExamNameList, setTotalPagesExamNameList] = useState(0);
    const [totalPagesExamLessonList, setTotalPagesExamLessonList] = useState(0);
    const [totalPagesExamTopicList, setTotalPagesExamTopicList] = useState(0);
    const [totalPagesExamSubTopicList, setTotalPagesExamSubTopicList] = useState(0);


    const [examNameSort, setExamNameSort] = useState(null);
    const [competitiveLessonNameSort, setCompetitiveLessonNameSort] = useState(null);
    const [competitiveTopicNameSort, setCompetitiveTopicNameSort] = useState(null);
    const [competitiveSubTopicNameSort, setCompetitiveSubTopicNameSort] = useState(null);

    const [searchValueExamNameList, setSearchValueExamNameList] = useState(null);
    const [searchValueExamLessonList, setSearchValueExamLessonList] = useState(null);
    const [searchValueExamTopicList, setSearchValueExamTopicList] = useState(null);
    const [searchValueExamSubTopicList, setSearchValueExamSubTopicList] = useState(null);

    const searchKeysExamName = ["examName"];
    const searchKeysExamLesson = ["competitiveLessonName"];
    const searchKeysExamTopic = ["competitiveTopicName"];
    const searchKeysExamSubTopic = ["competitiveSubTopicName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getExamNameList();
        getExamLessonList();
        getExamTopicList();
        getExamSubTopicList();
    }, [])

    const getApiUrlExamNameList = () => {
        return `/get-competitive-exam-names`;
    }

    const getApiUrlExamLessonList = () => {
        return `/get-dashboard-competitive-lesson`;
    }

    const getApiUrlExamTopicList = () => {
        return `/get-dashboard-competitive-topic`;
    }

    const getApiUrlExamSubTopicList = () => {
        return `/get-dashboard-competitive-sub-topic`;
    }

    const getExamNameList = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlExamNameList();
            const response = await authorizedAxios.get(apiUrl);
            setExamNameList(response.data.result);
        } catch (error) {
            setExamNameList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const getExamLessonList = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlExamLessonList();
            const response = await authorizedAxios.get(apiUrl);
            setExamLessonList(response.data.result);
        } catch (error) {
            setExamLessonList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const getExamTopicList = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlExamTopicList();
            const response = await authorizedAxios.get(apiUrl);
            setExamTopicList(response.data.result);
        } catch (error) {
            setExamTopicList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const getExamSubTopicList = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlExamSubTopicList();
            const response = await authorizedAxios.get(apiUrl);
            setExamSubTopicList(response.data.result);
        } catch (error) {
            setExamSubTopicList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (searchValueExamNameList === '' && searchValueExamNameList !== null) {
            setCurrPageExamNameList(1);
            getExamNameList();
        }
    }, [searchValueExamNameList]);

    useEffect(() => {
        if (searchValueExamLessonList === '' && searchValueExamLessonList !== null) {
            setCurrPageExamLessonList(1);
            getExamLessonList();
        }
    }, [searchValueExamLessonList]);

    useEffect(() => {
        if (searchValueExamTopicList === '' && searchValueExamTopicList !== null) {
            setCurrPageExamTopicList(1);
            getExamTopicList();
        }
    }, [searchValueExamTopicList]);

    useEffect(() => {
        if (searchValueExamSubTopicList === '' && searchValueExamSubTopicList !== null) {
            setCurrPageExamSubTopicList(1);
            getExamSubTopicList();
        }
    }, [searchValueExamSubTopicList]);

    const handleEmptySearchExamNameList = (e) => {
        setSearchValueExamNameList(e.target.value);
    }

    const handleEmptySearchExamLessonList = (e) => {
        setSearchValueExamLessonList(e.target.value);
    }

    const handleEmptySearchExamTopicList = (e) => {
        setSearchValueExamTopicList(e.target.value);
    }

    const handleEmptySearchExamSubTopicList = (e) => {
        setSearchValueExamSubTopicList(e.target.value);
    }

    const handleSearchExamNameList = async () => {
        if (searchValueExamNameList !== null) {
            setCurrPageExamNameList(1);
            setExamNameList(await searchArray("A", getApiUrlExamNameList(), searchKeysExamName, searchValueExamNameList.trim()));
        }
    }

    const handleSearchExamLessonList = async () => {
        if (searchValueExamLessonList !== null) {
            setCurrPageExamLessonList(1);
            setExamLessonList(await searchArray("A", getApiUrlExamLessonList(), searchKeysExamLesson, searchValueExamLessonList.trim()));
        }
    }

    const handleSearchExamTopicList = async () => {
        if (searchValueExamTopicList !== null) {
            setCurrPageExamTopicList(1);
            setExamTopicList(await searchArray("A", getApiUrlExamTopicList(), searchKeysExamTopic, searchValueExamTopicList.trim()));
        }
    }

    const handleSearchExamSubTopicList = async () => {
        if (searchValueExamSubTopicList !== null) {
            setCurrPageExamSubTopicList(1);
            setExamSubTopicList(await searchArray("A", getApiUrlExamSubTopicList(), searchKeysExamSubTopic, searchValueExamSubTopicList.trim()));
        }
    }

    useEffect(() => {
        setTotalPagesExamNameList(Math.ceil(examNameList.length / itemsPerPageExamNameList));
        const startIndexExamNameList = (currPageExamNameList - 1) * itemsPerPageExamNameList;
        let endIndexPdf = startIndexExamNameList + itemsPerPageExamNameList;

        if (endIndexPdf > examNameList.length) {
            endIndexPdf = examNameList.length;
        }
        setStartIndexExamNameList(startIndexExamNameList);
        setDisplayedDataExamNameList(examNameList.slice(startIndexExamNameList, endIndexPdf));
    }, [examNameList, currPageExamNameList, itemsPerPageExamNameList]);

    useEffect(() => {
        setTotalPagesExamLessonList(Math.ceil(examLessonList.length / itemsPerPageExamLessonList));
        const startIndexExamLessonList = (currPageExamLessonList - 1) * itemsPerPageExamLessonList;
        let endIndexReference = startIndexExamLessonList + itemsPerPageExamLessonList;

        if (endIndexReference > examLessonList.length) {
            endIndexReference = examLessonList.length;
        }
        setStartIndexExamLessonList(startIndexExamLessonList);
        setDisplayedDataExamLessonList(examLessonList.slice(startIndexExamLessonList, endIndexReference));
    }, [examLessonList, currPageExamLessonList, itemsPerPageExamLessonList])

    useEffect(() => {
        setTotalPagesExamTopicList(Math.ceil(examTopicList.length / itemsPerPageExamTopicList));
        const startIndexExamTopicList = (currPageExamTopicList - 1) * itemsPerPageExamTopicList;
        let endIndexSyllabus = startIndexExamTopicList + itemsPerPageExamTopicList;

        if (endIndexSyllabus > examTopicList.length) {
            endIndexSyllabus = examTopicList.length;
        }
        setStartIndexExamTopicList(startIndexExamTopicList);
        setDisplayedDataExamTopicList(examTopicList.slice(startIndexExamTopicList, endIndexSyllabus));
    }, [examTopicList, currPageExamTopicList, itemsPerPageExamTopicList])

    useEffect(() => {
        setTotalPagesExamSubTopicList(Math.ceil(examSubTopicList.length / itemsPerPageExamSubTopicList));
        const startIndexExamSubTopicList = (currPageExamSubTopicList - 1) * itemsPerPageExamSubTopicList;
        let endIndexVideo = startIndexExamSubTopicList + itemsPerPageExamSubTopicList;

        if (endIndexVideo > examSubTopicList.length) {
            endIndexVideo = examSubTopicList.length;
        }
        setStartIndexExamSubTopicList(startIndexExamSubTopicList);
        setDisplayedDataExamSubTopicList(examSubTopicList.slice(startIndexExamSubTopicList, endIndexVideo));
    }, [examSubTopicList, currPageExamSubTopicList, itemsPerPageExamSubTopicList])



    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Competitive Exam List</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i>Competitive Exam List</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="d-grid gap-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <button className={`${activeTab === "name" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("name")} >Exam Name</button>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <button className={`${activeTab === "lesson" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("lesson")} >Lesson</button>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <button className={`${activeTab === "topic" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("topic")} >Topic</button>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <button className={`${activeTab === "subtopic" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("subtopic")} >Sub Topic</button>
                                                            </div>
                                                        </div>

                                                        {activeTab == "name" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueExamNameList}
                                                                        onChange={handleEmptySearchExamNameList}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchExamNameList();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchExamNameList}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Exam Name
                                                                                <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setExamNameList} setCurrPage={setCurrPageExamNameList} sortingPath={"examName"} />
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataExamNameList?.length > 0 ?
                                                                                displayedDataExamNameList?.map((exam, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{startIndexExamNameList + index + 1}</th>
                                                                                            <td>{exam.examName}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Exam Name Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageExamNameList} setCurrPage={setCurrPageExamNameList} totalPages={totalPagesExamNameList} itemsPerPage={itemsPerPageExamNameList} setItemsPerPage={setItemsPerPageExamNameList} totalItem={examNameList.length} />
                                                            </div>}

                                                        {activeTab == "lesson" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueExamLessonList}
                                                                        onChange={handleEmptySearchExamLessonList}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchExamLessonList();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchExamLessonList}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Competitive Lesson Name
                                                                                <SortIcon sortState={competitiveLessonNameSort} setSortState={setCompetitiveLessonNameSort} setData={setExamLessonList} setCurrPage={setCurrPageExamLessonList} sortingPath={"competitiveLessonName"} />
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataExamLessonList?.length > 0 ?
                                                                                displayedDataExamLessonList?.map((lesson, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{startIndexExamLessonList + index + 1}</th>
                                                                                            <td>{lesson.competitiveLessonName}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Lesson Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageExamLessonList} setCurrPage={setCurrPageExamLessonList} totalPages={totalPagesExamLessonList} itemsPerPage={itemsPerPageExamLessonList} setItemsPerPage={setItemsPerPageExamLessonList} totalItem={examLessonList.length} />
                                                            </div>}

                                                        {activeTab == "topic" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueExamTopicList}
                                                                        onChange={handleEmptySearchExamTopicList}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchExamTopicList();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchExamTopicList}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Competitive Topic Name
                                                                                <SortIcon sortState={competitiveTopicNameSort} setSortState={setCompetitiveTopicNameSort} setData={setExamTopicList} setCurrPage={setCurrPageExamTopicList} sortingPath={"competitiveTopicName"} />
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataExamTopicList?.length > 0 ?
                                                                                displayedDataExamTopicList?.map((topic, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <th scope="row" className='sl_no'>{startIndexExamTopicList + index + 1}</th>
                                                                                            <td>{topic?.competitiveTopicName}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Topic Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageExamTopicList} setCurrPage={setCurrPageExamTopicList} totalPages={totalPagesExamTopicList} itemsPerPage={itemsPerPageExamTopicList} setItemsPerPage={setItemsPerPageExamTopicList} totalItem={examTopicList.length} />
                                                            </div>}

                                                        {activeTab == "subtopic" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueExamSubTopicList}
                                                                        onChange={handleEmptySearchExamSubTopicList}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchExamSubTopicList();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchExamSubTopicList}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Competitive Sub Topic Name
                                                                                <SortIcon sortState={competitiveSubTopicNameSort} setSortState={setCompetitiveSubTopicNameSort} setData={setExamSubTopicList} setCurrPage={setCurrPageExamSubTopicList} sortingPath={"competitiveSubTopicName"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Sub Topic Details
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataExamSubTopicList?.length > 0 ?
                                                                                displayedDataExamSubTopicList?.map((subtopic, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{startIndexExamSubTopicList + index + 1}</th>
                                                                                            <td>{subtopic?.competitiveSubTopicName}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                    setVisible(!visible)
                                                                                                    setModalData(subtopic.details)
                                                                                                }}><i class="fa fa-eye"></i></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Sub Topic Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageExamSubTopicList} setCurrPage={setCurrPageExamSubTopicList} totalPages={totalPagesExamSubTopicList} itemsPerPage={itemsPerPageExamSubTopicList} setItemsPerPage={setItemsPerPageExamSubTopicList} totalItem={examSubTopicList.length} />
                                                            </div>}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />


            <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
                onIni
            >
                <div className="book book-modal">
                    <div className='table-header-like'> Sub Topic Details</div>
                    <div className="page" dangerouslySetInnerHTML={{
                        __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData}</div>`
                    }}></div>
                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                        Close
                    </button>
                </div>
            </CModal>
        </>
    )
};

export default DashboardCompetitiveExam;